import type { CommittedMove, GameState } from "./logic"
import type { MovingBall } from "../shared-sortaballs/use-ball-game"

import { INITIAL_STATE } from "./initial-state"
import { useBallGame } from "../shared-sortaballs/use-ball-game"

// Ball Sort's UI state hook — the shared reducer engine bound to this game's
// defaults (legacy 5-plate initialState, capacity 4).
export const useBallSort = (
	initialBoard: GameState = INITIAL_STATE,
	capacity = 4,
	initialMoves: CommittedMove[] = [],
)=>
	useBallGame(initialBoard, capacity, initialMoves)

export type { MovingBall }